import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { useState } from 'react';
import { useTracker } from '../tracking/useTracker';
import { EmailDataInput } from './EmailDataInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GoogleWorkspaceEmailSignup = ({
  emailSignupEnabled
}) => {
  const [isEmailFormVisible, setIsEmailFormVisible] = useState(false);
  const Tracker = useTracker();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlock: "500",
      marginInline: "auto",
      maxInlineSize: "420px",
      paddingInline: "400",
      children: /*#__PURE__*/_jsx(TFlex, {
        backgroundColor: "border-tertiary-default",
        blockSize: "1px"
      })
    }), !isEmailFormVisible && /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      maxInlineSize: "420px",
      paddingInline: "400",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(Button, {
        "data-test-id": "signup-with-different-email-button",
        use: "unstyled",
        onClick: () => {
          Tracker.signupInteraction('click-signup-with-different-email');
          setIsEmailFormVisible(true);
        },
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "link-25",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "views.LANDING_PAGE.signupWithDifferentEmail"
          })
        })
      })
    }), emailSignupEnabled && isEmailFormVisible && /*#__PURE__*/_jsx(EmailDataInput, {})]
  });
};